import SwalAlert from 'Global/Components/CommonComponents/SwalAlert/SwalAlert';
import Cookies from 'js-cookie';
import { Post } from 'Xhr/Xhr';
import { env } from 'env';

export const GetSurveyForm = async (
  setGatheredData,
  parameters
) => {
  // console.log('survey output data =>', {
  //   idElsFormPatient: parameters?.user?.patientFormID || 0,
  //   formID: parameters?.user?.formID,
  //   patientFormID: 1,
  //   idPatient: parameters?.user?.IdPatient,
  //   idType: parameters?.user?.idType,
  //   idConfer: parameters?.user?.idConfer,
  //   AlloEdit:
  //     parameters?.user?.patientFormID !== 0 ? false : true,
  //   idCartablPatient: 0,
  //   idPerson: 1, //nazar sanji ""
  // });

  return Post(
    'POST',
    `${process.env.REACT_APP_API_URL_API_GET_SURVEY_DATA}`,
    false,
    {
      idElsFormPatient:
        parameters?.user?.patientFormID || 0,
      formID: parameters?.user?.formID,
      patientFormID: 1,
      idPatient: parameters?.user?.IdPatient,
      idType: parameters?.user?.idType,
      idConfer: parameters?.user?.idConfer,
      AlloEdit:
        parameters?.user?.patientFormID !== 0
          ? false
          : true,
      idCartablPatient: 0,
      idPerson: 1, //nazar sanji ""
    }
  ).then((response) => {
    // console.log(response.data);
    if (response.data.resCode === 1) {
      setGatheredData((prev) => ({
        ...prev,
        [parameters?.ObjName1]:
          response?.data?.Data?.Form?.GroupList,
        [parameters?.ObjName2]:
          response?.data?.Data?.ListDetail?.map((el) => ({
            ...el,
            Value:
              el?.Value === '0'
                ? ''
                : el?.Value === null
                ? ''
                : el?.Value,
          })),
        [parameters?.ObjName3]:
          response?.data?.Data?.Form?.Id,
        [parameters?.ObjName4]:
          response?.data?.Data?.IdCartbalePatient,
      }));
    } else {
      SwalAlert('error', response.data.resMessage, false);
    }
  });
};
// (prev) => ({
//     // ...prev,
//     // [parameters?.ObjName1]: response?.data?.Data?.Form?.GroupList,
//     // [parameters?.ObjName2]: response?.data?.Data?.Form?.ListDetail,
//     // [parameters?.ObjName3]: response?.data?.Data?.Form?.Id,
//     // [parameters?.ObjName4]: response?.data?.Data?.IdCartbalePatient,
//   })
